import commonState from '../commons/state'
import Warmup from '../../../models/warmup'

const state = () => ({
  ...commonState,
  currentActivity: Warmup,
  updateActivity: Warmup,
})

export default state